// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "voice_clinic_line".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "voice_clinic_line" table (1:1 with a DB row, on the wire). */
export const voiceClinicLineAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    number: z.string(),
    label: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=voiceClinicLine.js.map